'use client'

import Link from 'next/link'
import { LuCar, LuCircleAlert, LuCircleCheck } from 'react-icons/lu'

import { cn } from '@/core/utils/common'
import { useViewer } from '@/features/viewer/hooks/use-viewer'

import { fitsVehicle } from '../lib/product-rules'

import type { Route } from 'next'

export default function CompatNotice({ vehicleIds }: { vehicleIds: string[] }) {
  const { viewer, isLoading } = useViewer()
  const vehicle = viewer?.vehicle

  if (!vehicle) {
    return (
      <p
        className={cn(
          'type-ui flex items-center gap-2 rounded-control bg-surface-soft px-4 py-3',
          isLoading && !viewer && '[&>*]:invisible'
        )}
      >
        <LuCar aria-hidden="true" className="size-5 shrink-0" />
        <span>
          <Link href="/vehicles" className="font-medium underline">
            내 차를 선택
          </Link>
          하면 호환 여부를 바로 알려드립니다.
        </span>
      </p>
    )
  }
  if (fitsVehicle({ vehicleIds }, vehicle.id)) {
    return (
      <p className="type-ui flex items-center gap-2 rounded-control bg-surface-soft px-4 py-3 font-medium text-success">
        <LuCircleCheck aria-hidden="true" className="size-5 shrink-0" />
        {vehicle.name}에 호환되는 상품입니다.
      </p>
    )
  }
  return (
    <p className="type-ui flex flex-wrap items-center gap-2 rounded-control bg-surface-soft px-4 py-3 font-medium text-error">
      <LuCircleAlert aria-hidden="true" className="size-5 shrink-0" />
      {vehicle.name}용 상품이 아닙니다.
      <Link
        href={`/products?vehicle=${vehicle.id}` as Route}
        className="font-normal text-foreground underline"
      >
        내 차 상품 보기
      </Link>
    </p>
  )
}
